/**
 * useRotationHistory — the campaign's recorded rotation runs (newest first)
 * plus the optimizer's "last checked" stamp. Always enabled so the History
 * pill can show its count before the view is opened.
 * For Media Devoted | Created By Ciro Autiero
 */

import { useQuery } from '@tanstack/react-query';

import { getRotationHistory } from '@/features/flow-optimizer/services/flow-optimizer-queue-api';
import { queueKeys } from '@/features/flow-optimizer/hooks/useFlowOptimizerQueue';
import type { QueueProvider } from '@/features/trackers/flow-optimizer/queue-provider';

export function useRotationHistory(
  campaignId: string,
  provider: QueueProvider,
) {
  return useQuery({
    queryKey: queueKeys.rotationHistory(provider, campaignId),
    queryFn: () => getRotationHistory(campaignId, provider),
    enabled: Boolean(campaignId),
    staleTime: 15_000,
  });
}
